import {DropdownOption} from '../types';
import {useOptionListValidator, Validated} from './useOptionListValidator';
import {NewItem, SaveableItem, useSaveableItemList} from './useSaveableItemList';

export type UnsavedDropdownOption = Validated<SaveableItem<DropdownOption>>;

export function useDropdownOptions(initialOptions: readonly DropdownOption[] | undefined): {
	options: UnsavedDropdownOption[];
	addOption: (option: NewItem<DropdownOption>) => void;
	editOption: (option: SaveableItem<DropdownOption>, value: Partial<DropdownOption>) => void;
	removeOption: (option: SaveableItem<DropdownOption>) => void;
} {
	const {
		items: unvalidatedOptions,
		addItem: addOption,
		editItem: editOption,
		removeItem: removeOption,
	} = useSaveableItemList<DropdownOption>(initialOptions);

	const validatedOptions = useOptionListValidator(unvalidatedOptions);
	return {options: validatedOptions, addOption, editOption, removeOption};
}
